import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import { AgentEventsActions } from '@/agent/events/store/slice'
import { ArtifactsActions } from '@/artifacts/store/slice'
import { getTrackEventGlobal } from '@/analytics/utils/analytics-helpers'
import { observeArtifactVersionForGenerationAnalytics, observeArtifactVersionIdLinkedToConversation } from '@/analytics/utils/artifact-generation-analytics'
import type { ArtifactVersionRead } from '@/artifacts/schemas'
import type { RootState } from '@/store/store'

export const artifactGenerationAnalyticsMiddleware = createListenerMiddleware()

const generatingVersionIds = new Set<string>()
const trackedVersionIds = new Set<string>()

const start = artifactGenerationAnalyticsMiddleware.startListening.withTypes<RootState>()

start({
  matcher: isAnyOf(ArtifactsActions.upsertArtifactVersion, ArtifactsActions.upsertArtifactVersions),
  effect: (action, listenerApi) => {
    const track = getTrackEventGlobal()
    if (!track) return

    const state = listenerApi.getState()
    const versions = ArtifactsActions.upsertArtifactVersions.match(action) ? action.payload : [action.payload as ArtifactVersionRead]

    for (const artifactVersion of versions) {
      observeArtifactVersionForGenerationAnalytics({
        artifactVersion,
        generatingVersionIds,
        trackedVersionIds,
        track,
        state,
      })
    }
  },
})

start({
  actionCreator: AgentEventsActions.updateArtifactVersionId,
  effect: (action, listenerApi) => {
    const track = getTrackEventGlobal()
    if (!track) return

    const { conversationId, artifactVersionId } = action.payload
    if (!artifactVersionId) return

    observeArtifactVersionIdLinkedToConversation({
      artifactVersionId,
      conversationId,
      generatingVersionIds,
      trackedVersionIds,
      track,
      state: listenerApi.getState(),
    })
  },
})
